import { useEffect } from 'react';

/**
 * The wall and everything drawn on it — the photo of a boulder, the board's
 * grid — with the panel that acts on the mark in hand inside it.
 */
export const DRAWING_SURFACE_ATTRIBUTE = 'data-drawing-surface';

/**
 * What is still in hand, and where the answer stops being "this".
 *
 * A press on the picture is part of the drawing, and the panel that acts on the
 * mark stands on the picture, so neither lets go of it. A press anywhere else —
 * the name field, the grade, the empty page beside the photo — is the setter
 * having finished with that mark.
 *
 * Dialogs are portalled to the end of the body, outside the surface, so they are
 * named here too: the legend is opened *from* the picture and would otherwise
 * close what opened it.
 */
const KEEPS_SELECTION = [
  `[${DRAWING_SURFACE_ATTRIBUTE}]`,
  '[role="dialog"]',
  '[data-radix-popper-content-wrapper]',
].join(', ');

export function useClearSelectionOutside(clear: () => void) {
  useEffect(() => {
    function onPointerDown(event: PointerEvent) {
      const target = event.target as Element | null;
      if (target?.closest?.(KEEPS_SELECTION)) return;
      clear();
    }

    document.addEventListener('pointerdown', onPointerDown);
    return () => document.removeEventListener('pointerdown', onPointerDown);
  }, [clear]);
}
